import Gravatar from 'features/common/ui/utils/Gravatar'
import { getAvatarData, UserLike } from 'features/users/model/user'
import { Avatar, AvatarProps } from '@carto/meridian-ds/components'
import CartoUserAvatar from './CartoUserAvatar'

type UserAvatarProps = AvatarProps & {
  user: UserLike
  AvatarComponent?: React.ComponentType<AvatarProps>
}

function UserAvatar({ user, size = 'medium', AvatarComponent = Avatar, ...avatarProps }: UserAvatarProps) {
  const isCartoUser = user.user_metadata?.is_carto_user
  const avatarData = getAvatarData(user)

  if (isCartoUser) {
    return <CartoUserAvatar size={size} {...avatarProps} />
  }
  return <Gravatar {...avatarData} size={size} AvatarComponent={AvatarComponent} {...avatarProps} />
}

export default UserAvatar
